import { Grid, HStack, Stack, StackDivider, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { MdOutlineOpenInNew } from 'react-icons/md';
import { ROLES } from '@constants';
import useAuthRole from '@hooks/useAuthRole';

const WorkflowDocsCardV2 = ({
    referenceId,
    documentId,
    linkToDoc,
    isRejected,
    rejectionReason,
    documentSource,
    createdAt,
    updatedAt,
    doc,
    userId,
    onViewRejectionReason,
    onViewDocClick
  }) => {
    const { hasAnyAuthority } = useAuthRole();
    
    // Check if user has authority to view documents
    const canViewDocument = hasAnyAuthority(
      ROLES.ADMIN_ROLE,
      ROLES.TRANSFER_COMPLIANCE_MGR_READ,
      ROLES.TRANSFER_COMPLIANCE_MGR_WRITE
    );
    
    // Debug: Log user's roles
    return (
      <VStack
        w={{ base: '100%', md: '100%' }}
        maxW={'800px'}
        bg="backGround"
        borderRadius="12px"
        divider={
          <StackDivider style={{ margin: '0' }} borderColor="whiteAlpha.300" />
        }
      >
        <Grid
          gridTemplateColumns={'repeat(2,auto)'}
          rowGap={2}
          w={'90%'}
          justifyContent="space-between"
          m={'1rem'}
        >
          <HStack>
            <Text fontSize={{ base: 'sm', sm: 'md' }} color="gray">
              {referenceId}
            </Text>
          </HStack>
  
          <HStack>
            {canViewDocument && (
              <Text
                fontSize={{ base: 'sm', sm: 'md' }}
                color="white"
                target='_blank'
                as={'button'}
                rel='noopener noreferrer'
                onClick={onViewDocClick}
              >
                View Document
              </Text>
            )}
          </HStack>
        </Grid>
        <Grid
          gridTemplateColumns={{
            base: '1fr',
            md: `1fr 1fr 1fr 115px 115px`
          }}
          gap={2}
          alignItems={'flex-start'}
          w={'90%'}
          m={'1rem'}
          textAlign={{ base: 'end', md: 'start' }}
        >
          <Stack
            direction={{ base: 'row', md: 'column' }}
            justifyContent={'space-between'}
            height={'100%'}
          >
            <Text fontSize={'sm'} color={'gray'}>
              Document Id
            </Text>
            <Text fontSize={'sm'} color={'white'}>
              {documentId}
            </Text>
          </Stack>
          <Stack
            direction={{ base: 'row', md: 'column' }}
            justifyContent={'space-between'}
            height={'100%'}
          >
            <Text fontSize={'sm'} color={'gray'}>
              Is Rejected
            </Text>
            {isRejected == true ? (
              <MdOutlineOpenInNew
                color={'red'}
                cursor={'pointer'}
                onClick={() =>
                  onViewRejectionReason(rejectionReason)
                }
              />
            ) : (
              <Text fontSize={'sm'} color={'white'}>
                No
              </Text>
            )}
          </Stack>
          <Stack
            direction={{ base: 'row', md: 'column' }}
            justifyContent={'space-between'}
            height={'100%'}
          >
            <Text fontSize={'sm'} color={'gray'}>
              Document Source
            </Text>
            {documentSource ? (
              <Text fontSize={'sm'} color={'white'}>
                {documentSource}
              </Text>
            ) : (
              <Text fontSize={'sm'} color={'white'}>
                -
              </Text>
            )}
          </Stack>
          <Stack
            direction={{ base: 'row', md: 'column' }}
            justifyContent={'space-between'}
            height={'100%'}
          >
            <Text fontSize={'sm'} color={'gray'}>
              Created At
            </Text>
            {createdAt ?
              (
                <Text fontSize={'sm'} color={'white'}>
                  {createdAt}
                </Text>
              ) : (
                <Text fontSize={'sm'} color={'white'}>
                  -
                </Text>
              )}
          </Stack>
        </Grid>
      </VStack>
    );
  };
  
  export default WorkflowDocsCardV2;